import React from 'react';

import { useIdentity } from '../../../../hooks';
import TopicTag from './TopicTag';

const TopicList = ({ identityId }) => {
  const { identity, isIdentityLoading } = useIdentity(identityId);

  return (
    <>
      {isIdentityLoading ? (
        'Loading...'
      ) : identity ? (
        identity.followedEntities.length > 0 ? (
          identity.followedEntities.map((entity) => (
            <TopicTag key={entity.id} entity={entity} identityId={identityId} />
          ))
        ) : (
          <span>You have not added any topic interests. You can add them above.</span>
        )
      ) : (
        'Sorry, there was an issue while loading topic data. Please try again later.'
      )}
    </>
  );
};

export default TopicList;
